import { useState } from "react";
import { useNavigate, useLocation, Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { LogIn, Hammer } from "lucide-react";

export default function AdminLoginPage() {
    const { user, login, loading } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();
    const loc = useLocation();
    const [searchParams] = useSearchParams();
    const sessionMsg = searchParams.get("reason") === "session"
        ? "Tu sesión se cerró porque se inició sesión en otro equipo o navegador."
        : "";

    if (loading) return <div className="p-10 text-center font-mono text-sm">Cargando…</div>;
    if (user) {
        const target = loc.state?.from?.pathname || "/admin";
        return <Navigate to={target} replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            await login(email, password);
            nav("/admin");
        } catch (e2) {
            setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--lz-navy)] grid-blueprint p-4" data-testid="admin-login-page">
            <div className="w-full max-w-md bg-white border-2 border-[var(--lz-navy)] shadow-[8px_8px_0_0_#f26522]">
                <div className="bg-[var(--lz-navy)] text-white p-6 flex items-center gap-3">
                    <span className="inline-flex items-center justify-center w-10 h-10 bg-[var(--lz-orange)] text-[var(--lz-navy)]"><Hammer className="w-5 h-5" /></span>
                    <div>
                        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--lz-orange)]">Panel Administrativo</div>
                        <div className="font-display text-2xl font-bold uppercase">Ferretería Lozmar</div>
                    </div>
                </div>
                <form onSubmit={submit} className="p-6 space-y-4">
                    <div>
                        <label className="text-xs font-bold uppercase tracking-widest mb-1 block">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="lz-input"
                            placeholder="admin@lozmar.com"
                            data-testid="admin-login-email"
                        />
                    </div>
                    <div>
                        <label className="text-xs font-bold uppercase tracking-widest mb-1 block">Contraseña</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="lz-input"
                            placeholder="••••••••"
                            data-testid="admin-login-password"
                        />
                    </div>
                    {sessionMsg && (
                        <div className="text-sm text-amber-900 bg-amber-50 border-2 border-amber-600 p-2" data-testid="admin-session-replaced">
                            {sessionMsg}
                        </div>
                    )}
                    {err && <div className="text-sm text-red-700 bg-red-50 border-2 border-red-700 p-2" data-testid="admin-login-error">{err}</div>}
                    <button type="submit" disabled={busy} className="lz-btn lz-btn-primary w-full" data-testid="admin-login-submit">
                        {busy ? "Entrando…" : (<><LogIn className="w-4 h-4" /> Iniciar Sesión</>)}
                    </button>
                </form>
            </div>
        </div>
    );
}
